import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import AppErrorBoundary from './components/AppErrorBoundary';
import './index.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
const pathname = window.location.pathname.replace(/\/+$/, '') || '/';
const isHomePage = pathname === '/home' || pathname === '/home.html' ||
  pathname.startsWith('/home-3') || pathname.startsWith('/home-4');
if (pathname === '/stories') {
  document.title = '轩辕国学 · 玄学故事';
} else if (pathname === '/theory') {
  document.title = '轩辕国学 · 基础知识';
} else if (pathname === '/origin-memory') {
  document.title = '轩辕国学 · 象意速记';
} else {
  document.title = isHomePage ? '轩辕国学' : '轩辕国学 · 奇门排盘';
}

root.render(
  <React.StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </React.StrictMode>
);
